import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import './GlobalTopbar.scss';

/** Describe the component */

const GlobalTopbar = props => {
  const {
    contentRight,
    contentLeft,
    hamburgerClassName,
    logo,
    toggleNav,
  } = props;

  return (
    <div className="global-topbar">
      <div className="topbar-left">
        {toggleNav && (
          <button
            className={classnames(
              'unstyled-button topbar-hamburger',
              hamburgerClassName
            )}
            onClick={toggleNav}
            type="button"
          >
            <div className="hamburger-bar">
              {hamburgerClassName === 'menu-open'
                ? 'Close Navigation'
                : 'Open Navigation'}
            </div>
          </button>
        )}
        {logo && (
          <Link className="topbar-logo" to="/">
            {logo}
          </Link>
        )}
        {contentLeft && (
          <div className="topbar-left-content">{contentLeft}</div>
        )}
      </div>
      {contentRight && <div className="topbar-right">{contentRight}</div>}
    </div>
  );
};

GlobalTopbar.propTypes = {
  /** Space to put user, help dropdowns etc */
  contentRight: PropTypes.node,
  contentLeft: PropTypes.node,
  /** Open/Closed hamburger classNames */
  hamburgerClassName: PropTypes.string,
  /** Logo image or element */
  logo: PropTypes.node,
  /** Open close nav function for mobile */
  toggleNav: PropTypes.func,
};

GlobalTopbar.defaultProps = {
  contentRight: null,
  contentLeft: null,
  hamburgerClassName: null,
  logo: null,
  toggleNav: null,
};

export default GlobalTopbar;
